import { useRouter } from 'next/router';
import React from 'react';
import { ArrowBack } from 'ui/Icons/ArrowBack';

import { Title, Wrapper } from './styles';

interface Props {
  title?: string | null;
  isBoxShadow?: boolean;
}

export default function SalesRepNavBar({ title, isBoxShadow = true }: Props) {
  const router = useRouter();
  const homePath = (router.route.match(/[/]/g) || []).length <= 2;

  const checkRoutingForPDF = () => {
    if (router.asPath.includes('offering')) {
      router.push('/salesrep/offerings');
    }
  };

  return (
    <Wrapper homePath={homePath} isBoxShadow={isBoxShadow}>
      {homePath ? null : <ArrowBack onClick={() => checkRoutingForPDF()} />}
      <Title>{title}</Title>
    </Wrapper>
  );
}
